import Nizhnevartovsk from './coordinates/Nizhnevartovsk/Nizhnevartovsk.json';
import Divniy from './coordinates/Nizhnevartovsk/nizhnevartovsk poselok divniy.json';
import Solnechniy from './coordinates/Nizhnevartovsk/nizhnevartovsk poselok solnechniy.json';
import StariyVartovsk from './coordinates/Nizhnevartovsk/mikrorayon Stariy Vartovsk.json';
import Evropeyskiy from './coordinates/Nizhnevartovsk/nizhnevartovsk mikrorayon evropeyskiy(5p).json';
import REBFlota from './coordinates/Nizhnevartovsk/nizhnevartovsk REB flota.json';
import Izluchinsk from './coordinates/Nizhnevartovsk/p.g.t. Izluchinsk.json';

export default {
    regionCode: 'nignevartovsk',
    serviceAreas: [
        {
            id: 'nizhnevartovsk-1',
            include: [
                {
                    name: 'Нижневартовск',
                    type: 'polygon',
                    coordinates: Nizhnevartovsk,
                }
            ],
            exclude: [
                {
                    name: 'п. Дивный',
                    type: 'polygon',
                    coordinates: Divniy,
                },
                {
                    name: 'п. Солнечный',
                    type: 'polygon',
                    coordinates: Solnechniy,
                },
                {
                    name: 'микрорайон Старый Вартовск',
                    type: 'polygon',
                    coordinates: StariyVartovsk,
                },
                {
                    name: 'микрорайон Европейский',
                    type: 'polygon',
                    coordinates: Evropeyskiy,
                },
                {
                    name: 'РЭБ флота',
                    type: 'polygon',
                    coordinates: REBFlota,
                },
            ],
        },
        {
            id: 'nizhnevartovsk-2',
            include: [
                {
                    name: 'п. Дивный',
                    type: 'polygon',
                    coordinates: Divniy,
                },
                {
                    name: 'п. Солнечный',
                    type: 'polygon',
                    coordinates: Solnechniy,
                },
                {
                    name: 'микрорайон Старый Вартовск',
                    type: 'polygon',
                    coordinates: StariyVartovsk,
                },
                {
                    name: 'микрорайон Европейский (5п)',
                    type: 'polygon',
                    coordinates: Evropeyskiy,
                },
                {
                    name: 'РЭБ флота',
                    type: 'polygon',
                    coordinates: REBFlota,
                },
            ],
        },
        {
            id: 'nizhnevartovsk-3',
            include: [
                {
                    name: 'п.г.т. Излучинск',
                    type: 'polygon',
                    coordinates: Izluchinsk,
                }
            ]
        }
    ],
};
